export const defaultSwal2Options = () => ({
  reverseButtons: true,
  buttonsStyling: false
})
